import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0c3ec13b&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c3ec13b')) {
      api.createRecord('0c3ec13b', component.options)
    } else {
      api.reload('0c3ec13b', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=0c3ec13b&", function () {
      api.rerender('0c3ec13b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Audience/Listing/Components/Header.vue"
export default component.exports